import { render, staticRenderFns } from "./ClubsSummary.vue?vue&type=template&id=a9e4242e&scoped=true"
import script from "./ClubsSummary.vue?vue&type=script&lang=js"
export * from "./ClubsSummary.vue?vue&type=script&lang=js"
import style0 from "./ClubsSummary.vue?vue&type=style&index=0&id=a9e4242e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e4242e",
  null
  
)

export default component.exports